import TreeBranch from '@linc-technologies/linced-common/components/tree-branch';

// This app overrides the addon's template with the co-located
// tree-branch.hbs in this directory. An explicit subclass (rather than a
// bare re-export) is required so the build can unambiguously associate
// that co-located template with this component instead of the addon's own.
export default class extends TreeBranch {}
